import { AccordionDetails, AccordionSummary } from '@mui/material';
import React from 'react';
import { ExpandIconUpDown, extractProperty, NewText, ShareIconWhatsapp } from 'ui';
import PazomatService from '../PazomatService';
import { StyledAccordion, StyledAccordionWrapper, StyledContactTextCardsWrapper, StyledDeatilsText, StyledShareIconWrapper, StyledTabPanelWrapper } from '../styles';

type CustomerPazomatTabProps = {
    richTextTop: string;
    infoBlocks: any[]
};
const CustomerPazomatTab: React.FC<CustomerPazomatTabProps> = ({ richTextTop, infoBlocks }) => {
    return (
        <>
            <StyledTabPanelWrapper>
                <NewText
                    component={"p"}
                    largeDesktopFontSize={18}
                    desktopFontSize={14}
                    desktopLineHeight={"140%"}
                    mobileFontSize={18}
                    mobileLineHeight={"24px"}
                    desktopFontWeight={400}
                    mobileFontWeight={400}
                    dangerouslySetInnerHTML={{ __html: richTextTop }}
                ></NewText>
                <StyledContactTextCardsWrapper>
                    {infoBlocks.map((item: any) => {
                        const title = extractProperty(item, "title")
                        const content = extractProperty(item, "content")
                        return (
                            <div key={title}>
                                <NewText
                                    component={"h3"}
                                    largeDesktopFontSize={18}
                                    desktopFontSize={14}
                                    desktopLineHeight={"140%"}
                                    mobileFontSize={18}
                                    mobileLineHeight={"24px"}
                                    desktopFontWeight={400}
                                    mobileFontWeight={400}

                                >
                                    {title}
                                </NewText>
                                <StyledDeatilsText
                                    component={"p"}
                                    largeDesktopFontSize={18}
                                    desktopFontSize={14}
                                    desktopLineHeight={"140%"}
                                    mobileFontSize={18}
                                    mobileLineHeight={"24px"}
                                    desktopFontWeight={400}
                                    mobileFontWeight={400}
                                    dangerouslySetInnerHTML={{ __html: content }}
                                    style={{ margin: 0 }}
                                ></StyledDeatilsText>
                            </div>
                        )
                    })}
                </StyledContactTextCardsWrapper>
            </StyledTabPanelWrapper>

            <StyledAccordionWrapper>
                <StyledAccordion>
                    <AccordionSummary
                        aria-controls="panel1-content"
                        id="panel1-header"
                        expandIcon={<ExpandIconUpDown />}
                        style={{ display: "flex", alignItems: "center" }}
                        sx={{
                            "& .MuiAccordionSummary-content": {
                                alignItems: "center",
                                // margin: "20px 0"
                            },
                        }}
                    >
                        <StyledShareIconWrapper>
                            <ShareIconWhatsapp />
                        </StyledShareIconWrapper>
                        <NewText
                            component="span"
                            desktopFontSize={14}
                            largeDesktopFontSize={16}
                        >לחצו להשארת פניה</NewText>
                    </AccordionSummary>
                    <AccordionDetails>
                        <PazomatService />
                    </AccordionDetails >
                </StyledAccordion>
            </StyledAccordionWrapper>
        </>
    );
};
export default CustomerPazomatTab;
